export const isEmptyObject = obj => !obj || Object.keys(obj).length === 0
export const deepClone = obj => JSON.parse(JSON.stringify(obj))
export const isObject = item =>
  item !== null && !(item instanceof Array) && typeof item === "object"
